module.exports = __webpack_public_path__ + "img/marker2.380f2c97.png";